const initialState = [];

export default function boards(state=initialState, action) {

  switch (action.type) {

    case 'RESET_BOARDS':
      return initialState;

    case 'FETCH_BOARDS':
      return [...state, ...action.boards];

    case 'CREATE_BOARD':
      return [...state, ...action.board];

    case 'EDIT_BOARD':
      return [...state, ...action.board];

    case 'UPDATE_BOARD':
      return [...state, ...action.board];

    case 'DELETE_BOARD':
      return [...state, ...action.boardId];

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/boards.js